import debounce from 'lodash.debounce';
import { useCallback } from 'react';
const isFilterableReactElement = (x) => x.hasOwnProperty('props') &&
    (typeof x.props.children === 'string' || typeof x.key === 'string');
export const filter = (search, haystack) => {
    return haystack.filter(({ label }) => {
        const candidate = isFilterableReactElement(label)
            ? label.key || label.props.children
            : label;
        return candidate.toLowerCase().includes(search.toLowerCase());
    });
};
// Useful for search boxes narrowing anything with a `label` property. For disabled elements
// we add an optional tooltip on click which explains why they're disabled. Because this is
// a ReactElement, we need to account for it in the filter. If it has a string child, we can
// filter by it; if not, we ignore it.
export const useFilterByLabel = (f) => useCallback(debounce((needle, haystack) => {
    if (haystack.length === 0) {
        f([]);
        return;
    }
    const search = needle.toLowerCase();
    f(filter(search, haystack));
}, 300), []);
